import { render, staticRenderFns } from "./Composer.vue?vue&type=template&id=fd7b7ce8&scoped=true"
import script from "./Composer.vue?vue&type=script&lang=js"
export * from "./Composer.vue?vue&type=script&lang=js"
import style0 from "./Composer.vue?vue&type=style&index=0&id=fd7b7ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7b7ce8",
  null
  
)

export default component.exports